const global = {
	domain: '//live.pochanyun.net',
	base: {
	  url: '//live.pochanyun.net/api',
	  api: '//live.pochanyun.net/api'
	},
	file: {
	  url: '//live.pochanyun.net/api'
	},
  fileTypeMimes: {
    'Attach': '*',
    'Image': 'image/gif,image/jpeg,image/bmp,image/png',
    'Pdf': 'application/pdf',
    'Excel': 'application/vnd.ms-excel',
    'ImgPdf': 'image/gif,image/jpeg,image/bmp,image/png,application/pdf'
  }
}

export default global